import { render } from "./verifyemail.vue?vue&type=template&id=61f20842"
import script from "./verifyemail.vue?vue&type=script&lang=js"
export * from "./verifyemail.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__